import type { CiudadVivaEvent } from "./events";

// "Avísame": aviso por correo a las 10:00 (hora del evento) del día antes.
// Misma regla que el backend (ciudad-server/src/reminders/reminder-dates.util.ts):
// solo funciones desde pasado mañana — si el evento es hoy, mañana o ya
// empezó, ya no alcanzamos a avisar el día antes.

export const REMINDER_HOUR = "10:00";

const DAY_MS = 24 * 60 * 60 * 1000;

function todayIn(timezone: string): string {
  try {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: timezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date());
  } catch {
    return todayIn("America/Santiago");
  }
}

// "2026-10-18" + n días (fechas de calendario, sin zona horaria).
export function addDays(ymd: string, days: number): string {
  return new Date(new Date(`${ymd}T00:00:00Z`).getTime() + days * DAY_MS).toISOString().slice(0, 10);
}

// Si el evento admite aviso (no cancelado ni terminado).
export function supportsReminder(event: CiudadVivaEvent): boolean {
  return event.status !== "canceled" && event.active !== false;
}

// Próxima función avisable ("YYYY-MM-DD") o null si ya no alcanza.
export function nextRemindableDate(event: CiudadVivaEvent): string | null {
  const min = addDays(todayIn(event.timezone ?? "America/Santiago"), 2);
  const dates = (event.dates?.length ? event.dates : [event.dateStartISO])
    .filter((d): d is string => !!d)
    .sort();
  return dates.find((d) => d >= min) ?? null;
}
